import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Handle } from 'src/app/handle';
import { MatDialogRef, MatSnackBar, MatDialog, MatTableDataSource } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { ComponentTabController } from 'src/app/tab-controller';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';

// const DATA = [
//   { descripcion: 'Capacidad máxima AM.', control: 'CAPMAXAM' },
//   { descripcion: 'Capacidad máxima PM.', control: 'CAPMAXPM' },
// ];

const DATA = [
  { descripcion: '1. Bocas del Toro', control1: 'CAPMAXAM1', control2: 'CAPMAXPM1' },
  { descripcion: '2. Coclé', control1: 'CAPMAXAM2', control2: 'CAPMAXPM2' },
  { descripcion: '3. Colón', control1: 'CAPMAXAM3', control2: 'CAPMAXPM3' },
  { descripcion: '4. Chiriquí', control1: 'CAPMAXAM4', control2: 'CAPMAXPM4' },
  { descripcion: '5. Darién', control1: 'CAPMAXAM5', control2: 'CAPMAXPM5' },
  { descripcion: '6. Herrera', control1: 'CAPMAXAM6', control2: 'CAPMAXPM6' },
  { descripcion: '7. Los Santos', control1: 'CAPMAXAM7', control2: 'CAPMAXPM7' },
  { descripcion: '8. Panamá', control1: 'CAPMAXAM8', control2: 'CAPMAXPM8' },
  { descripcion: '9. Panamá Oeste', control1: 'CAPMAXAM9', control2: 'CAPMAXPM9' },
  { descripcion: '10. Veraguas', control1: 'CAPMAXAM10', control2: 'CAPMAXPM10' },
];

const DATA1 = [
  { id: 1, descripcion: '1. Técnico Recolector Contrata', control1: 'CAPMAXAM_1', control2: 'CAPMAXPM_1' },
  { id: 2, descripcion: '2. Técnico Recolector Interno', control1: 'CAPMAXAM_2', control2: 'CAPMAXPM_2' },
];

@Component({
  selector: 'app-config-contrata',
  templateUrl: './config-contrata.component.html',
  styleUrls: ['./config-contrata.component.scss']
})
export class ConfigContrataComponent implements OnInit {

  displayedColumns: string[] = ['descripcion', 'control1', 'control2'];
  dataSource = DATA;
  capacidadxprovincia = false;

  /**
   * ---------- CONFIG 2
   */
  displayedColumns1: string[] = ['descripcion', 'control1', 'control2', 'acciones'];
  displayedColumns2: string[] = ['FECHA', 'TURNO', 'PROVINCIA', 'ACCION'];
  listaSub: any[] = [];
  dataSource1 = DATA1;
  dataSource2: any;
  provincias = [];
  minDate = new Date();

  grupoVal2 = new FormGroup({
    horaam: new FormControl('', [
      Validators.required,
      Validators.pattern(/^([0][0-9]|1[0-1]):[0-5][0-9]$/) // 00:00 - 11:59
    ]),
    horapm: new FormControl('', [
      Validators.required,
      Validators.pattern(/^([0-1][0-9]|2[0-3]):[0-5][0-9]$/) // 00:00 - 23:59
    ]),
    fecha: new FormControl('', [Validators.required]),
    turno: new FormControl('', [Validators.required]),
    provincia: new FormControl('', [Validators.required])
  });

  constructor(
    private snackbar: MatSnackBar,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public Handle: Handle,
    private localsave: LocalSaveService,
    private dialogRef: MatDialogRef<ConfigContrataComponent>,
    public tabController: ComponentTabController,
    private dialog: MatDialog,
  ) { }

  ngOnInit() {
    // this.spinner.show();

    this.gateway.get('getcapacidadxtipotecnico', { IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU, IDAREA: this.localsave.get('usuarioPGV').IDAREA }).then((result) => {
      let aux: any = result;
      let aux1: any, aux2: any, aux3: any, aux4: any, aux5: any, aux6: any, aux7: any, aux8: any, aux9: any, aux10: any = null;
      if (aux.rows.length) {
        aux = aux.rows[0];
        this.grupoVal1.controls.CAPMAXAM_1.setValue(aux.contrata_am_capacity);
        this.grupoVal1.controls.CAPMAXPM_1.setValue(aux.contrata_pm_capacity);
        this.grupoVal1.controls.CAPMAXAM_2.setValue(aux.interno_am_capacity);
        this.grupoVal1.controls.CAPMAXPM_2.setValue(aux.interno_pm_capacity);
      }
    });

    if (this.capacidadxprovincia) {
      this.displayedColumns = ['descripcion', 'control']
      this.gateway.get('getcapacidad', { IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU }).then((result) => {
        let aux: any = result;
        if (aux.rows.length == 10) {
          aux = aux.rows[0];
          this.grupoVal.controls.CAPMAXAM.setValue(aux.am_capacity);
          this.grupoVal.controls.CAPMAXPM.setValue(aux.pm_capacity);
        }

      });
    } else {
      this.displayedColumns = ['descripcion', 'control1', 'control2']
      this.gateway.get('getcapacidadxprovincia', { IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU }).then((result) => {
        let aux: any = result;
        let aux1: any, aux2: any, aux3: any, aux4: any, aux5: any, aux6: any, aux7: any, aux8: any, aux9: any, aux10: any = null;
        if (aux.rows.length == 10) {
          aux1 = aux.rows[0];
          aux2 = aux.rows[1];
          aux3 = aux.rows[2];
          aux4 = aux.rows[3];
          aux5 = aux.rows[4];
          aux6 = aux.rows[5];
          aux7 = aux.rows[6];
          aux8 = aux.rows[7];
          aux9 = aux.rows[8];
          aux10 = aux.rows[9];
          this.grupoVal.controls.CAPMAXAM1.setValue(aux1.am_capacity);
          this.grupoVal.controls.CAPMAXPM1.setValue(aux1.pm_capacity);
          this.grupoVal.controls.CAPMAXAM2.setValue(aux2.am_capacity);
          this.grupoVal.controls.CAPMAXPM2.setValue(aux2.pm_capacity);
          this.grupoVal.controls.CAPMAXAM3.setValue(aux3.am_capacity);
          this.grupoVal.controls.CAPMAXPM3.setValue(aux3.pm_capacity);
          this.grupoVal.controls.CAPMAXAM4.setValue(aux4.am_capacity);
          this.grupoVal.controls.CAPMAXPM4.setValue(aux4.pm_capacity);
          this.grupoVal.controls.CAPMAXAM5.setValue(aux5.am_capacity);
          this.grupoVal.controls.CAPMAXPM5.setValue(aux5.pm_capacity);
          this.grupoVal.controls.CAPMAXAM6.setValue(aux6.am_capacity);
          this.grupoVal.controls.CAPMAXPM6.setValue(aux6.pm_capacity);
          this.grupoVal.controls.CAPMAXAM7.setValue(aux7.am_capacity);
          this.grupoVal.controls.CAPMAXPM7.setValue(aux7.pm_capacity);
          this.grupoVal.controls.CAPMAXAM8.setValue(aux8.am_capacity);
          this.grupoVal.controls.CAPMAXPM8.setValue(aux8.pm_capacity);
          this.grupoVal.controls.CAPMAXAM9.setValue(aux9.am_capacity);
          this.grupoVal.controls.CAPMAXPM9.setValue(aux9.pm_capacity);
          this.grupoVal.controls.CAPMAXAM10.setValue(aux10.am_capacity);
          this.grupoVal.controls.CAPMAXPM10.setValue(aux10.pm_capacity);
        }
      });
    }

    this.gateway.get('getprovincias', {}).then((result) => {
      let aux: any = result;
      this.provincias = aux.rows;
    });

    this.gateway.get('getconfig2xarea', {
      // IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU,
      IDAREA: this.localsave.get('usuarioPGV').IDAREA
    }).then((result: any) => {

      if (!result) return;

      // Guardar las horas generales
      this.grupoVal2.get('horaam').setValue(result.HORAAM || '');
      this.grupoVal2.get('horapm').setValue(result.HORAPM || '');

      // Cargar la lista de configuraciones
      const lista = result.LISTA_SUB || [];

      this.listaSub = lista.map((element: any) => ({
        ...element,
        fecha: new Date(element.fecha + 'T00:00:00')
      }));

      // Ordenar por fecha, provincia y turno (AM → PM)
      this.listaSub.sort((a, b) => {
        const fechaA = new Date(a.fecha).getTime();
        const fechaB = new Date(b.fecha).getTime();
        if (fechaA !== fechaB) return fechaA - fechaB;

        const provinciaA = a.provincia.idprovincia;
        const provinciaB = b.provincia.idprovincia;
        if (provinciaA !== provinciaB) return provinciaA - provinciaB;

        // AM antes que PM
        return a.turno === 'AM' && b.turno === 'PM' ? -1 :
          a.turno === 'PM' && b.turno === 'AM' ? 1 : 0;
      });

      // Refrescar la tabla
      this.dataSource2 = new MatTableDataSource<any>(this.listaSub);

    }).catch((error) => {
      this.snackbar.open('Error al cargar la configuración del área', 'Cerrar', { duration: 3000 });
    });

    this.dataSource2 = new MatTableDataSource<any>(this.listaSub);

  }

  //  Añadir configuración a la tabla

  addConfigFecha() {
    const fecha = this.grupoVal2.get('fecha').value;
    const turno = this.grupoVal2.get('turno').value;
    const provincia = this.grupoVal2.get('provincia').value;
    const horaam = this.grupoVal2.get('horaam').value;
    const horapm = this.grupoVal2.get('horapm').value;

    if (!fecha || !turno || !provincia) {
      this.snackbar.open('Debe completar Fecha, Turno y Provincia.', 'Cerrar', { duration: 3000 });
      return;
    }

    // Evitar duplicados
    const existe = this.listaSub.some(
      x =>
        x.fecha.getTime() == fecha.getTime() &&
        x.turno == turno &&
        x.provincia.idprovincia == provincia.idprovincia
    );

    if (existe) {
      this.snackbar.open('Ya existe una configuración con esa fecha, turno y provincia', 'Cerrar', { duration: 3000 });
      return;
    }

    const nuevo = {
      fecha,
      turno,
      provincia,
      horaam,
      horapm
    };

    this.listaSub.push(nuevo);

    // 🔹 Reordenar: Fecha → Provincia → Turno (AM antes que PM)
    this.listaSub.sort((a, b) => {
      // 1️⃣ Ordenar por fecha
      const diffFecha = new Date(a.fecha).getTime() - new Date(b.fecha).getTime();
      if (diffFecha !== 0) return diffFecha;

      // 2️⃣ Luego por idprovincia
      const diffProv = a.provincia.idprovincia - b.provincia.idprovincia;
      if (diffProv !== 0) return diffProv;

      // 3️⃣ Finalmente por turno (AM antes que PM)
      if (a.turno === 'AM' && b.turno === 'PM') return -1;
      if (a.turno === 'PM' && b.turno === 'AM') return 1;
      return 0;
    });

    // Actualizar tabla
    this.dataSource2 = [...this.listaSub];

    // Limpiar campos
    this.grupoVal2.get('fecha').reset();
    this.grupoVal2.get('turno').reset();
    this.grupoVal2.get('provincia').reset();
  }

  borrarConfigFecha(element: any) {
    const index = this.listaSub.findIndex(sub =>
      sub.fecha.getTime() === element.fecha.getTime() &&
      sub.turno === element.turno &&
      sub.provincia.idprovincia === element.provincia.idprovincia
    );

    if (index > -1) {
      this.listaSub.splice(index, 1);

      // 🔹 Reordenar: Fecha → Provincia → Turno
      this.listaSub.sort((a, b) => {
        const diffFecha = new Date(a.fecha).getTime() - new Date(b.fecha).getTime();
        if (diffFecha !== 0) return diffFecha;

        const diffProv = a.provincia.idprovincia - b.provincia.idprovincia;
        if (diffProv !== 0) return diffProv;

        if (a.turno === 'AM' && b.turno === 'PM') return -1;
        if (a.turno === 'PM' && b.turno === 'AM') return 1;
        return 0;
      });

      this.dataSource2 = [...this.listaSub];

      this.snackbar.open('Registro eliminado correctamente', '', { duration: 3000 });
    } else {
      this.snackbar.open('No se encontró el registro a eliminar', '', { duration: 3000 });
    }
  }

  guardar1(tipotecnico: any) {
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '500px',
      data: { sms: ` cambiar los cupos de todos los Técnicos Recolectores ${tipotecnico == 1 ? 'Contrata' : 'Interno'}`, addcomment: false }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.resp) {
        let RECORD = {
          IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU,
          IDAREA: this.localsave.get('usuarioPGV').IDAREA,
          CAPMAXAM1: this.grupoVal1.controls.CAPMAXAM_1.value,
          CAPMAXPM1: this.grupoVal1.controls.CAPMAXPM_1.value,
          CAPMAXAM2: this.grupoVal1.controls.CAPMAXAM_2.value,
          CAPMAXPM2: this.grupoVal1.controls.CAPMAXPM_2.value,
          TIPOTECNICO: tipotecnico
        }
        this.spinner.show();
        this.gateway.get('modificarcapacidadxtipotecnico', RECORD).then((result) => {
          // this.dialogRef.close();
          this.spinner.hide();
          this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
        }
        ).catch(function (e) {
          this.spinner.hide();
        });
      }
    });

  }

  guardar2() {
    this.spinner.show();
    const params = {
      HORAAM: this.grupoVal2.get('horaam').value,
      HORAPM: this.grupoVal2.get('horapm').value,
      LISTA_SUB: this.listaSub,
      IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU,
      IDAREA: this.localsave.get('usuarioPGV').IDAREA,
    }
    this.gateway.save('modifyconfig2xarea', params).then((result) => {
      // console.log('========')
      // console.log(result)
      // console.log('/=/=======')
      this.spinner.hide();
      this.dialogRef.close(true);
    }
    ).catch(function (e) {
    });
  }

  tabChanged(event) {
    // alert(event.index)
  }

  guardar() {
    if (this.capacidadxprovincia) {
      let RECORD = {
        IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU,
        CAPMAXAM: this.grupoVal.controls.CAPMAXAM.value,
        CAPMAXPM: this.grupoVal.controls.CAPMAXPM.value,
      }

      this.spinner.show();
      this.gateway.save('modificarcapacidad', RECORD).then((result) => {
        this.dialogRef.close();
        this.spinner.hide();
        this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
      }
      ).catch(function (e) {
      });
    }
    else {
      let RECORD = {
        IDDISTRIBUIDOR: this.localsave.get('usuarioPGV').IDU,
        CAPMAXAM1: this.grupoVal.controls.CAPMAXAM1.value,
        CAPMAXPM1: this.grupoVal.controls.CAPMAXPM1.value,
        CAPMAXAM2: this.grupoVal.controls.CAPMAXAM2.value,
        CAPMAXPM2: this.grupoVal.controls.CAPMAXPM2.value,
        CAPMAXAM3: this.grupoVal.controls.CAPMAXAM3.value,
        CAPMAXPM3: this.grupoVal.controls.CAPMAXPM3.value,
        CAPMAXAM4: this.grupoVal.controls.CAPMAXAM4.value,
        CAPMAXPM4: this.grupoVal.controls.CAPMAXPM4.value,
        CAPMAXAM5: this.grupoVal.controls.CAPMAXAM5.value,
        CAPMAXPM5: this.grupoVal.controls.CAPMAXPM5.value,
        CAPMAXAM6: this.grupoVal.controls.CAPMAXAM6.value,
        CAPMAXPM6: this.grupoVal.controls.CAPMAXPM6.value,
        CAPMAXAM7: this.grupoVal.controls.CAPMAXAM7.value,
        CAPMAXPM7: this.grupoVal.controls.CAPMAXPM7.value,
        CAPMAXAM8: this.grupoVal.controls.CAPMAXAM8.value,
        CAPMAXPM8: this.grupoVal.controls.CAPMAXPM8.value,
        CAPMAXAM9: this.grupoVal.controls.CAPMAXAM9.value,
        CAPMAXPM9: this.grupoVal.controls.CAPMAXPM9.value,
        CAPMAXAM10: this.grupoVal.controls.CAPMAXAM10.value,
        CAPMAXPM10: this.grupoVal.controls.CAPMAXPM10.value,
      }

      this.spinner.show();
      this.gateway.save('modificarcapacidadxprovincia', RECORD).then((result) => {
        this.dialogRef.close();
        this.spinner.hide();
        this.snackbar.open('Datos almacenados con éxito.', 'Cerrar', { duration: 3000, });
      }
      ).catch(function (e) {
      });
    }

  }

  onNoClick() {
    this.dialogRef.close();
  }

  grupoVal = new FormGroup({
    CAPMAXAM: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),

    CAPMAXAM1: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM1: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM2: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM2: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM3: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM3: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM4: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM4: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM5: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM5: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM6: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM6: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM7: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM7: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM8: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM8: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM9: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM9: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXAM10: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
    CAPMAXPM10: new FormControl(1, [Validators.compose([Validators.required, Validators.min(1), Validators.pattern('^[1-9][0-9]*')])]),
  });

  grupoVal1 = new FormGroup({
    CAPMAXAM_1: new FormControl(3, [Validators.compose([Validators.required, Validators.min(0), Validators.pattern('^[0-9][0-9]*')])]),
    CAPMAXPM_1: new FormControl(4, [Validators.compose([Validators.required, Validators.min(0), Validators.pattern('^[0-9][0-9]*')])]),
    CAPMAXAM_2: new FormControl(3, [Validators.compose([Validators.required, Validators.min(0), Validators.pattern('^[0-9][0-9]*')])]),
    CAPMAXPM_2: new FormControl(4, [Validators.compose([Validators.required, Validators.min(0), Validators.pattern('^[0-9][0-9]*')])]),
  });

}
